import { AvatarImage } from '../..';
import ProfileMenu from '../../ProfileMenu';

import { enhance } from './enhancers';
import styles from './styles.module.scss';
import arrow from './arrow.svg';

const Profile = ({
  user,
  product,
  profileMenuOpen,
  handleProfileClick,
  handleMenuClose,
}) => (
  <div onClick={handleProfileClick} className={styles.profile}>
    <span className={styles.message}>Hi {user?.displayName}!</span>
    <AvatarImage avatar={user?.avatarV2} className={styles.avatar} />
    <img src={arrow} className={styles.arrow} draggable={false} />
    {!!profileMenuOpen && (
      <ProfileMenu
        product={product}
        name={user?.displayName}
        onClose={handleMenuClose}
        className={styles.menu}
      />
    )}
  </div>
);

export default enhance(Profile);
